import { IPagination } from 'app/types/common';

export interface IPaymentCollectionsState {
  readonly paymentCollectionsById?: any;
  readonly paymentCollectionIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddPaymentCollection?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentCollectionIds?: string[];
  readonly currentPaymentCollectionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentCollectionsSelector extends IPaymentCollectionsState {
  readonly currentPaymentCollection?: any;
  readonly currentFormPaymentCollection?: any;
  readonly getPaymentCollectionsFilteredByTagInSelectFormat?: any;
  readonly paymentCollectionsByIdInSelectFormat?: any;
}

export enum PaymentCollectionsActionTypes {
  GET_ALL_PAYMENT_COLLECTIONS_REQUESTED = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_REQUESTED',
  GET_ALL_PAYMENT_COLLECTIONS_PENDING = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_PENDING',
  GET_ALL_PAYMENT_COLLECTIONS_SUCCESS = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_SUCCESS',
  GET_ALL_PAYMENT_COLLECTIONS_FAIL = 'redux-app/payment-collections/GET_ALL_PAYMENT_COLLECTIONS_FAIL',
  GET_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_REQUESTED',
  GET_PAYMENT_COLLECTION_PENDING = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_PENDING',
  GET_PAYMENT_COLLECTION_SUCCESS = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_SUCCESS',
  GET_PAYMENT_COLLECTION_FAIL = 'redux-app/payment-collections/GET_PAYMENT_COLLECTION_FAIL',
  UPDATE_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/UPDATE_PAYMENT_COLLECTION_REQUESTED',
  UPDATE_PAYMENT_COLLECTION_PENDING = 'redux-app/payment-collections/UPDATE_PAYMENT_COLLECTION_PENDING',
  UPDATE_PAYMENT_COLLECTION_SUCCESS = 'redux-app/payment-collections/UPDATE_PAYMENT_COLLECTION_SUCCESS',
  UPDATE_PAYMENT_COLLECTION_FAIL = 'redux-app/payment-collections/UPDATE_PAYMENT_COLLECTION_FAIL',
  CREATE_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/CREATE_PAYMENT_COLLECTION_REQUESTED',
  CREATE_PAYMENT_COLLECTION_PENDING = 'redux-app/payment-collections/CREATE_PAYMENT_COLLECTION_PENDING',
  CREATE_PAYMENT_COLLECTION_SUCCESS = 'redux-app/payment-collections/CREATE_PAYMENT_COLLECTION_SUCCESS',
  CREATE_PAYMENT_COLLECTION_FAIL = 'redux-app/payment-collections/CREATE_PAYMENT_COLLECTION_FAIL',
  DELETE_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/DELETE_PAYMENT_COLLECTION_REQUESTED',
  DELETE_PAYMENT_COLLECTION_PENDING = 'redux-app/payment-collections/DELETE_PAYMENT_COLLECTION_PENDING',
  DELETE_PAYMENT_COLLECTION_SUCCESS = 'redux-app/payment-collections/DELETE_PAYMENT_COLLECTION_SUCCESS',
  DELETE_PAYMENT_COLLECTION_FAIL = 'redux-app/payment-collections/DELETE_PAYMENT_COLLECTION_FAIL',
  SELECT_PAYMENT_COLLECTION_REQUESTED = 'redux-app/payment-collections/SELECT_PAYMENT_COLLECTION_REQUESTED',
  CLEAR_PAYMENT_COLLECTIONS = 'redux-app/payment-collections/CLEAR_PAYMENT_COLLECTIONS',
}

export default null;
